'use client';

import { useCallback } from 'react';
import { dispatchCopyLinkEvent } from '@frameio/shared/components/CopyLink';
import { UPLOAD_LINK_GROUP_ID } from '@frameio/shared/upload-links/constants';

export { UPLOAD_LINK_GROUP_ID };

export function useCopyUploadLink() {
  return useCallback(async (url: string) => {
    await navigator.clipboard?.writeText(url);
    dispatchCopyLinkEvent(UPLOAD_LINK_GROUP_ID, url);
  }, []);
}
